module.exports = __webpack_public_path__ + "img/logo_en_sm.0ab571c9.svg";